import { CancelToken } from "axios";
import API from "./API";

export default {

   getUserRoles: async() => {
      const { data } = await API.get<DictionaryItem[]>( "/dictionaries/roles" );
      return data;
   },

   getCounties: async() => {
      const { data } = await API.get<DictionaryItem[]>( "/dictionaries/counties" );
      return data;
   },

   getVoivodeships: async() => {
      const { data } = await API.get<DictionaryItem[]>( "/dictionaries/voivodeships" );
      return data;
   },

   getDocumentTypes: async() => {
      const { data } = await API.get<DocTypeItem[]>( "/dictionaries/document-types" );
      return data
   },

   getTerritorialUnits: async( search: string, cancelToken?: CancelToken ) => {
      const { data } = await API.get<DictionaryItem[]>( "/dictionaries/territorial-units", {
         params: { search },
         cancelToken
      });

      return data;
   }
}